import Vue from 'vue'

import { RealtimeService } from '@/services/realtime-service';
import { bellNotifications, toastNotifications } from '@/services/realtime-service/subscriptions';

const realtime = new RealtimeService(Vue);

const RealtimePlugin = {
  install(Vue) {
    // Making the $realtime plugin available for all Vue components - also those in the amp builder
    Vue.prototype.$realtime = realtime;
  },
};

Vue.use(RealtimePlugin);

export default function (ctx, inject) {
  realtime.init(ctx);

  // ORGANIZATION SCOPED SUBSCRIPTIONS
  realtime.subscribeToOrganizationChannel(toastNotifications(ctx));

  // USER SCOPED SUBSCRIPTIONS
  realtime.subscribeToUserChannel(bellNotifications(ctx));

  inject('realtime', realtime);
}
